import React from 'react'
import bestEyelashExtensionBanner from "./../../../../../Images/Blog/The_Best_Eyelash_Extension/Banner.png";

const BestEyelashExtensionImg = () => {
  return (
    <div className="blogImg-content">
      <img src={bestEyelashExtensionBanner} alt="Best Eyelash Extension Banner" loading="lazy" />
    </div>
  )
}

export default BestEyelashExtensionImg
